import PhotoSwipe from "photoswipe/dist/photoswipe.min.js";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default.min.js";

function initSwipeGallery() {
    var images = [];
    var bodyObj = document.body;
    var imageItems = document.querySelectorAll(".imageZoom");

    var gallery = document.querySelectorAll(".gallery");
    for (var i = 0; i < gallery.length; i++) {
        if (gallery[i].hasAttribute("data-gallery-name")) {
            imageItems = document.querySelectorAll(".galleryImage");
        }
    }

    var promises = Array.from(imageItems).map(function(e, index) {
        return new Promise(function(resolve, reject) {
            const img = new Image();
            img.src = e.getAttribute("data-src");

            img.onload = function() {
                const item = {
                    el: e,
                    src: img.src,
                    w: img.naturalWidth,
                    h: img.naturalHeight,
                    title: e.getAttribute("data-caption")
                };

                images[index] = item;
                resolve();
            };

            img.onerror = function() {
                reject(new Error("Error on loading image."));
            };
        });
    });

    Promise.all(promises)
        .then(function() {
            openGallery();
        })
        .catch(function(error) {
            // eslint-disable-next-line no-console
            console.error("There was an issue on loading the images:", error);
        });

    function getThumbBounds(index) {
        var thumbnail = imageItems[index];
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    }

    function openGallery() {
        Array.from(imageItems).forEach(function(e, index) {
            e.addEventListener("click", function() {
                var pswpElement = document.querySelectorAll(".pswp")[0];
                var options = {
                    index: index,
                    shareEl: false,
                    galleryPIDs: true,
                    captionEl: true,
                    counterEl: true,
                    getThumbBoundsFn: getThumbBounds,
                    fitImagesInViewport: true,
                    maxSpreadZoom: 2,
                    minZoom: 0.5
                };

                //push nav & footer back on open
                bodyObj.classList.add("body--pushToBack");
                bodyObj.classList.add("photoswipe");

                var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, images, options);

                //push nav & footer forward on close
                gallery.listen("destroy", function() {
                    bodyObj.classList.remove("body--pushToBack");
                    bodyObj.classList.remove("photoswipe");
                });

                gallery.init();
            });
        });
    }
}

function init() {
    initSwipeGallery();
}

export default { init };
